import { Navigate, useParams, useSearchParams } from "react-router";

import { Skeleton } from "@/components/ui/skeleton";
import {
	StageForm,
	StageFormSkeleton,
} from "@/features/stages/components/stage-form";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { useStages } from "@/features/stages/hooks/use-stages.ts";
import { isStageKind } from "@/features/stages/utils/kind.ts";

export function EtapaCreatePage() {
	const { obra: obraKey } = useParams();
	const [searchParams] = useSearchParams();
	const { obra, isLoading } = useActiveObra();
	const stagesQuery = useStages(obra?.id);

	const listPath = `/${obraKey}/etapas`;

	if (isLoading || (obra && stagesQuery.isPending)) {
		return (
			<div className="stage-create-page">
				<div className="page-header-skeleton">
					<Skeleton className="page-header-skeleton__title" />
					<Skeleton className="page-header-skeleton__subtitle" />
				</div>
				<StageFormSkeleton />
			</div>
		);
	}

	if (!obra || stagesQuery.data?.lock.locked) {
		return <Navigate to={listPath} replace />;
	}

	const requestedKind = searchParams.get("kind");

	return (
		<div className="stage-create-page">
			<div>
				<h1 className="page-title">Nova Etapa</h1>
				<p className="page-subtitle">Adicione uma etapa à obra {obra.name}.</p>
			</div>

			<StageForm
				mode="create"
				constructionId={obra.id}
				stages={stagesQuery.data?.stages ?? []}
				defaultParentId={searchParams.get("parent") ?? undefined}
				defaultKind={isStageKind(requestedKind) ? requestedKind : undefined}
				listPath={listPath}
			/>
		</div>
	);
}
